import React from "react";
import { ChoiceButton } from "./ChoiceButton";
import { useS, ACTIVITIES, GOALS, TIMES, CHANNELS } from "../../lib/simple";

export const QUESTIONS = [
  { key: "activity", title: "q_activity", opts: ACTIVITIES, prefix: "act_" },
  { key: "goal", title: "q_goal", opts: GOALS, prefix: "goal_" },
  { key: "time", title: "q_time", sub: "q_time_sub", opts: TIMES, prefix: "time_" },
  { key: "channels", title: "q_channels", sub: "q_channels_sub", opts: CHANNELS, prefix: "ch_", multi: true },
];

const toggleChannel = (cur = [], c) => {
  if (c === "none") return cur.includes("none") ? [] : ["none"];
  const base = cur.filter((x) => x !== "none");
  return base.includes(c) ? base.filter((x) => x !== c) : [...base, c];
};

export function StarterQuestion({ q, answers, onChange }) {
  const { s } = useS();
  const val = answers[q.key];
  const pick = (o) => onChange(q.key, q.multi ? toggleChannel(val, o) : o);
  return (
    <div data-testid={`starter-q-${q.key}`}>
      <h1 className="font-display font-black text-2xl sm:text-3xl leading-tight">{s(q.title)}</h1>
      {q.sub && <p className="text-sm text-[hsl(var(--muted-foreground))] mt-2">{s(q.sub)}</p>}
      <div className="mt-6 space-y-2.5">
        {q.opts.map((o) => (
          <ChoiceButton key={o} testid={`starter-opt-${q.key}-${o}`} onClick={() => pick(o)}
            selected={q.multi ? (val || []).includes(o) : val === o}>
            {s(`${q.prefix}${o}`)}
          </ChoiceButton>
        ))}
      </div>
    </div>
  );
}
